'use client';

/**
 * CallBotFinalCTA — closes the page with the standard V3 final CTA
 * (violet halo, two-clause headline, primary + secondary CTAs).
 */

import React from 'react';
import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';
import FinalCTA from '../_shared/sections/FinalCTA';

type Props = { lang: Locale };

const CallBotFinalCTA = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  return (
    <FinalCTA
      accent="#A78BFA"
      ariaLabel={t('CallBot/FinalCTA/aria_label')}
      copy={{
        headlineA: t('CallBot/FinalCTA/title1'),
        headlineB: t('CallBot/FinalCTA/title2'),
        subhead: t('CallBot/FinalCTA/subtitle'),
        ctaPrimary: {
          label: t('CallBot/FinalCTA/cta_primary'),
          href: `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}/register`,
        },
        ctaSecondary: {
          label: t('CallBot/FinalCTA/cta_secondary'),
          href: `/${lang}/contact-us`,
        },
      }}
    />
  );
};

export default CallBotFinalCTA;
